<template>
    <div>
        <v-card raised class="mx-auto" max-width="570px">
            <form @submit.prevent="sendEmail">
                <v-card elevation="0" class="white--text" color="#004236">
                    <v-card-title class="text-h5">Re-Verify Email</v-card-title>
                </v-card>
                <v-card-text v-if="!emailsent">
                    <v-card-subtitle>
                        Please enter email address and password you used to create account precisely below.
                    </v-card-subtitle>
                    <v-text-field
                        label="Account Email"
                        v-model="currentUser.email"
                        outlined
                        prepend-icon="mdi-email"
                        :rules="[rules.required, rules.email]"
                    ></v-text-field>
                    <v-text-field
                        v-model="currentUser.password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required]"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                        outlined
                        prepend-icon="mdi-key-variant"
                        label="Password"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex justify-end">
                        <v-btn type="submit" dark color="#004236" :loading="loading">Send Verification Email</v-btn>
                    </v-col>
                </v-card-text>
                <v-card-text v-else>
                    <br />
                    <v-row justify="center" align="center">
                        <v-col cols="10" v-if="!verified">
                            Verification Email has been sent to <b>{{ currentUser.email }}</b>.<br />
                            Please check your spam, and trash if it does not come in to your inbox.<br />
                            If you do not get the email within 24 hours, please contact King's HR via <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or call at 519-433-3491.
                        </v-col>
                        <v-col cols="10" v-else>
                            Your email <b>{{ currentUser.email }}</b> is already verified.<br /><br />
                            If you cannot sign in using this email, please contact King's HR via <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or call at 519-433-3491.
                        </v-col>
                        <v-col cols="10">
                            <v-btn block dark color="#004236" to="/signin">Go back to Sign In</v-btn>
                        </v-col>
                    </v-row>
                    <br />
                </v-card-text>
            </form>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import firebase from "firebase";
require('firebase/auth')

export default {
    data() {
        return {
            currentUser: {   
                email: '',
                password: ''
            },
            rules: {
                required: value => !!value || 'Required Field.',
                email: v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Invalid email format"
            },
            show1: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 4000,
            loading: false,
            emailsent: false,
            verified: false
        };
    },
    methods: {
        sendEmail() {
            const that = this;
            that.loading = true;
            firebase.auth().signInWithEmailAndPassword(that.currentUser.email, that.currentUser.password)
            .then((u)=>{
                    if(!u.user.emailVerified){
                        u.user.sendEmailVerification();
                        that.emailsent = true;
                        that.verified = false;
                    }else {
                        that.emailsent = true;
                        that.verified = true;
                    }
                })
                .catch((err)=>{
                    that.setSnackbar(err, "#E53935");
                    that.loading = false;
                });
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
    }
};
</script>